import conditioner from '@parallaxagency/conditioner'
import { scrollTo } from './scroll.js'
import faqSearch from '../faq-search.js'

export default function allHelpSearch ($container, { $refs }) {
  let fetched = false
  let fetching = false
  let search

  let $form = $refs.form[0]
  let $input = $refs.input[0]

  function onSubmit (e) {
    e.preventDefault()
    scrollTo($refs.results[0], { scrollMode: 'always', offset: 100 })
  }

  function onInput () {
    if (!fetched && !fetching) {
      fetching = true
      window
        .fetch('/!/True/allFaqs')
        .then(res => res.text())
        .then(html => {
          $refs.results[0].innerHTML = html
          conditioner.hydrate($refs.results[0])
          search = faqSearch($container)
          fetching = false
          fetched = true
        })
    } else if (!fetching && fetched) {
      let term = $input.value.trim()
      if (term === '') {
        $refs.results[0].hidden = true
      } else {
        search.search(term)
        $refs.results[0].hidden = false
      }
    }
  }

  $form.addEventListener('submit', onSubmit)
  $input.addEventListener('input', onInput)

  return () => {
    $form.removeEventListener('submit', onSubmit)
    $input.removeEventListener('input', onInput)
  }
}



// WEBPACK FOOTER //
// ./src/js/components/all-help-search.js